export const assetUrl = (source: string) => {
	const cdnUrl =
		process.env.NEXT_PUBLIC_CDN_HOST_URL || "/cdn"
	return cdnUrl + source
}

export const cdnUrl = "https://filesw.zoomerang.info/blog"
export const appAddress = process.env.NEXT_PUBLIC_APP_HOST
export const superadmin = appAddress + "/superadmin"

export const HEADER_WEB_VERSION = 5
